import { Anchor, Toast } from "@newsela/angelou";

import { actionNames, objectTypes, withTrackEvent } from "@newsela/snitch";
import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import { toastCss, toastLinkCss } from "./assignmentToastHelpers.style";

const AnchorWithTrackEvent = withTrackEvent(Anchor);

const getAssignmentLinkEventProps = (currentContentLevelId, assignmentId) => ({
  objectType: objectTypes.assignment,
  actionName: actionNames.navigate,
  streamProperties: {
    content_id: currentContentLevelId,
    content_type: "Article",
    description: "Navigate to teacher assignments",
    object_id: assignmentId,
  },
});

const renderAssignmentsLink = (currentContentLevelId, assignmentId) => (
  <AnchorWithTrackEvent
    __cssFor={{ root: toastLinkCss }}
    href={`${MONOLITH_ORIGIN}/binder/assignments`}
    {...getAssignmentLinkEventProps(currentContentLevelId, assignmentId)}
  >
    See all assignments
  </AnchorWithTrackEvent>
);

const sharedToastProps = {
  showIcon: true,
  __cssFor: { root: toastCss },
};

export const getPrimaryToastProps = (message) => ({
  ...sharedToastProps,
  statusColor: Toast.statusColor.primary,
  children: message,
});

export const getSuccessToastProps = (
  message,
  currentContentLevelId,
  assignmentId,
) => ({
  ...sharedToastProps,
  statusColor: Toast.statusColor.success,
  children: (
    <>
      {message} {renderAssignmentsLink(currentContentLevelId, assignmentId)}
    </>
  ),
});

export const getErrorToastProps = (message) => ({
  ...sharedToastProps,
  statusColor: Toast.statusColor.danger,
  children: message,
});
